<template>
  <b-row>
    <b-col cols="12">
      <sites-table :key="$route.fullPath" />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import SitesTable from './SitesTable.vue'

export default {
  components: {
    BRow,
    BCol,
    SitesTable,
  },
}
</script>

<style lang="scss" >
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>
